import { render, staticRenderFns } from "./EmployeeDialog.vue?vue&type=template&id=3db87790&scoped=true&"
import script from "./EmployeeDialog.vue?vue&type=script&lang=js&"
export * from "./EmployeeDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDialog.vue?vue&type=style&index=0&id=3db87790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db87790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VDialog,
})
